export default __webpack_public_path__ + "4bf874a912149cdee030edf84286674e.png";